import { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const Generator = forwardRef<SVGSVGElement, SvgIconProps>(
  ({ color = 'white', width = '24', height = '16', ...props }, ref) => {
    return (
      <SvgIcon
        ref={ref}
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        sx={{
          backgroundColor: (theme) => theme.palette.badge2,
          borderRadius: 4,
          padding: '2px',
          width,
          height,
        }}
        {...props}
      >
        <g id="ElectricBoltRounded">
          <g id="Group 27">
            <g id="Group 24">
              <path
                id="Subtract"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.54736 3.60425H4.36963C4.09349 3.60425 3.86963 3.82811 3.86963 4.10425V11.983C3.86963 12.2591 4.09349 12.483 4.36963 12.483H18.3671C18.6433 12.483 18.8671 12.2591 18.8671 11.983V4.10425C18.8671 3.82811 18.6433 3.60425 18.3671 3.60425H16.945V8.29032C16.945 8.51123 16.7659 8.69032 16.545 8.69032H8.94736C8.72645 8.69032 8.54736 8.51123 8.54736 8.29032V3.60425Z"
                fill={color}
              />
              <path
                id="Subtract_2"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.86689 1.65137C9.70121 1.65137 9.56689 1.78568 9.56689 1.95137V7.3826C9.56689 7.54829 9.70121 7.6826 9.8669 7.6826H15.6277C15.7934 7.6826 15.9277 7.54829 15.9277 7.3826V1.95137C15.9277 1.78568 15.7934 1.65137 15.6277 1.65137H9.86689ZM11.0164 4.55166L13.3536 2.45809C13.4236 2.39267 13.5296 2.39492 13.5973 2.4626C13.6582 2.52351 13.6649 2.62052 13.6153 2.69046L12.5212 4.21551L14.3463 4.39148C14.5403 4.40953 14.6215 4.65092 14.4771 4.78177L12.1399 6.87533C12.07 6.94076 11.9639 6.9385 11.8962 6.87082C11.8353 6.80991 11.8286 6.7129 11.8782 6.64296L12.9724 5.11791L11.1473 4.94194C10.9532 4.92389 10.872 4.6825 11.0164 4.55166Z"
                fill={color}
              />
            </g>
            <g id="Group 25">
              <g id="Group 26">
                <rect
                  id="Rectangle 23"
                  x="4.77686"
                  y="12.9607"
                  width="3.76924"
                  height="0.890071"
                  rx="0.3"
                  fill={color}
                />
                <rect
                  id="Rectangle 25"
                  x="14.1938"
                  y="12.9607"
                  width="3.76727"
                  height="0.890071"
                  rx="0.3"
                  fill={color}
                />
              </g>
            </g>
          </g>
        </g>
      </SvgIcon>
    );
  }
);

Generator.displayName = 'Generator';
